<!-- if a user is anonymous, display a place holder avatar. -->
<ion-avatar
  *ngIf="userIsAnonymous()"
  [ngClass]="'size-' + size"
  aria-hidden="true"
>
  <img
    src="assets/img/mable/default_avatar.png"
    alt="person silhouette"
  />
</ion-avatar>

<!-- if avatar exists display avatar -->
<ion-avatar
  *ngIf="avatar && !userIsAnonymous()"
  [ngClass]="'size-' + size"
  (click)="enlargeImage()"
  aria-hidden="true"
>
  <img
    src="{{ avatar }}"
    alt="user avatar"
  />
</ion-avatar>

<!-- else display initials -->
<div
  *ngIf="!avatar && !userIsAnonymous() && user"
  [ngClass]="'user-avatar size-' + size"
  aria-hidden="true"
>
  <span [ngStyle]="{ 'font-size': font + 'px' }"> {{ initials }}</span>
</div>

<!-- If user object is null, show "?" -->
<div
  *ngIf="!user"
  [ngClass]="'user-avatar no-user size-' + size"
  aria-hidden="true"
>
  <span [ngStyle]="{ 'font-size': font + 'px' }">?</span>
</div>

<ion-badge
  [ngClass]="'size-' + size"
  class="availability"
  *ngIf="isOnline"
  color="green-500"
>
</ion-badge>
<ng-content select=".chip"></ng-content>
<ng-content select=".badge"></ng-content>
